import {
  Button,
  type ButtonProps,
} from '@livechat/design-system-react-components'

import { useOneClickPaymentContext } from '@/context/OneClickPayment'
import { useTypedDispatch } from '@/store/hooks'
import { logAmplitudeEvent } from '@/store/stats'
import useParamSelector from '@/hooks/useParamSelector'
import { getPublishedApp } from '@/store/selectors'
import { AMPLITUDE_EVENTS } from '@/constants'

interface Props extends ButtonProps {
  id: string
  onlyPrimaryButton?: boolean
}

export const BuyButton = (props: Props) => {
  const { className, onlyPrimaryButton, size, fullWidth, id, kind } = props

  const dispatch = useTypedDispatch()
  const { openModal } = useOneClickPaymentContext()
  const publishedApp = useParamSelector(getPublishedApp, id)

  const eventPayload = publishedApp
    ? {
        appId: publishedApp.id,
        appName: publishedApp.name,
      }
    : {}

  const handleClick = () => {
    dispatch(
      logAmplitudeEvent({
        name: `${AMPLITUDE_EVENTS.GET_CLICKED} - 1CP modal opened`,
        params: eventPayload,
      })
    )

    openModal()
  }

  return (
    <Button
      data-test="main-buy-btn"
      kind={kind || 'primary'}
      onClick={handleClick}
      className={className}
      size={onlyPrimaryButton ? size : 'medium'}
      fullWidth={fullWidth}
    >
      Get
    </Button>
  )
}

export default BuyButton
